import {
    POST,
    GET
} from "../util";

const inspectionUrl = "api/user-profile-inspection";
const operationUrl = "api/user-profile-operation";

const url = {
    inspection: {
        profile: `${inspectionUrl}/profile`,
    },
    operation: {
        editProfile: `${operationUrl}/edit-profile`,
        changePassword: `${operationUrl}/change-password`,
    }

};

const userProfileApi = {
    inspection: {
        getProfile: () => {
            return GET(url.inspection.profile);
        }
    },
    operation: {
        editProfile: (data) => {
            return POST(url.operation.editProfile, data);
        },
        changePassword: (data) => {
            return POST(url.operation.changePassword, data)
        }
    }
};
export {
    userProfileApi
};